<template>
  <div>
    <common-table
      :table-columns="tableColumns"
      :url="url"
      :operate="operate"
      :searchs="searchs"
      :form-fields="formFields"
      :permission="permission"
    />
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable/CommonTable'
export default {
  name: 'Setting',
  components: { CommonTable },
  data() {
    return {
      permission: {
        add: 'setting:add',
        update: 'setting:update',
        delete: 'setting:delete',
        deleteBatch: 'setting:deleteBatch',
      },
      url: {
        get: '/setting/listByCondition',
        add: '/setting/add',
        update: '/setting/update',
        delete: '/setting/delete/',
        delete_batch: '/setting/deleteBatch',
      },
      searchs: [
        /*{
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }*/
      ],
      tableColumns: [
        {
          field: 'id',
          label: 'ID',
          show: true,
        },
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
          width: '',
        },
        {
          field: 'title',
          label: '网站名称',
          show: true,
          width: '',
        },
        {
          field: 'run',
          label: '网站运行天数',
          show: false,
          width: '',
        },
        {
          field: 'bonus',
          label: '网站累计收益',
          show: false,
          width: '100',
        },
        {
          field: 'logo',
          label: '大logo',
          show: false,
          width: '',
          img: true,
        },
        {
          field: 'smallLogo',
          label: '小logo',
          show: false,
          width: '',
          img: true,
        },
        {
          field: 'icon',
          label: '网站图标',
          show: true,
          width: '',
          img: true,
        },
        {
          field: 'defaultPid',
          label: '代理默认pidId',
          selectData: [],
          selectUrl: '/pidSecret/getAll',
          show: false,
          // show: {
          //   type: 'select',
          // },
          // width: '',
        },
        {
          field: 'proxyWalletPid',
          label: '代理钱包默认pidId',
          selectData: [],
          selectUrl: '/pidSecret/getAll',
          show: false,
          // show: {
          //   type: 'select',
          // },
          // width: '',
        }, {
          field: 'feeRatio',
          label: '提现手续费比例',
       /*   show: {
            type: 'thousandthsRatio'
          },
          detail: true,*/
          show: false,
          width: '',
        },{
          field: 'timeScriptKey',
          label: '时间脚本秘钥',
          show: true,
          detail: true,
          width: '',
        },{
          field: 'timeScriptUrl',
          label: '时间脚本服务器地址',
          show: true,
          detail: true,
          width: '',
        },{
          field: 'timeScriptSelectUrl',
          label: '时间脚本查询服务器地址',
          show: true,
          detail: true,
          width: '',
        },{
          field: 'douYinReleaseAmount',
          label: '抖音每日发布额度',
          show: true,
          width: '',
        }, {
          field: 'createTime',
          label: '创建时间',
          show: true,
          width: '',
        },
      ],
      operate: [
       /* {
          icon: 'el-icon-upload2',
          type: 'text',
          text: '上传大log',
          uploadImg: true,
          url: this.reUrl + '/system/upload/oss/img',
          // 用于存储handle的row
          value: {},
          handle: (row) => {
            this.value = row
          },
          success: (res) => {
            if (res.code === 0) {
              const value = JSON.parse(JSON.stringify(this.value))
              value.img = res.data
              this.$axios.post({
                url: '/setting/img/update/1',
                data: value,
                success: (data) => {
                  if (data.code === 0) {
                    this.$message.success('图片上传成功')
                    this.$set(this.value, 'img', value.img)
                  } else {
                    this.$message.error(data.msg ? data.msg : '图片上传失败')
                  }
                },
              })
            } else if (res.code === 102) {
              window.localStorage.removeItem('username')
              window.localStorage.removeItem('sessionId')
              window.parent.location.href = this.feUrl + '/login.html'
            }
          },
        },
        {
          icon: 'el-icon-upload2',
          type: 'text',
          text: '上传小log',
          uploadImg: true,
          url: this.reUrl + '/system/upload/oss/img',
          // 用于存储handle的row
          value: {},
          handle: (row) => {
            this.value = row
          },
          success: (res) => {
            if (res.code === 0) {
              const value = JSON.parse(JSON.stringify(this.value))
              value.img = res.data
              this.$axios.post({
                url: '/setting/img/update/2',
                data: value,
                success: (data) => {
                  if (data.code === 0) {
                    this.$message.success('图片上传成功')
                    this.$set(this.value, 'img', value.img)
                  } else {
                    this.$message.error(data.msg ? data.msg : '图片上传失败')
                  }
                },
              })
            } else if (res.code === 102) {
              window.localStorage.removeItem('username')
              window.localStorage.removeItem('sessionId')
              window.parent.location.href = this.feUrl + '/login.html'
            }
          },
        },*/
        {
          icon: 'el-icon-upload3',
          type: 'text',
          text: '上传icon',
          uploadImg: true,
          url: this.reUrl + '/system/upload/oss/img',
          // 用于存储handle的row
          value: {},
          handle: (row) => {
            this.value = row
          },
          success: (res) => {
            if (res.code === 0) {
              const value = JSON.parse(JSON.stringify(this.value))
              value.img = res.data
              this.$axios.post({
                url: '/setting/img/update/3',
                data: value,
                success: (data) => {
                  if (data.code === 0) {
                    this.$message.success('图片上传成功')
                    this.$set(this.value, 'img', value.img)
                  } else {
                    this.$message.error(data.msg ? data.msg : '图片上传失败')
                  }
                },
              })
            } else if (res.code === 102) {
              window.localStorage.removeItem('username')
              window.localStorage.removeItem('sessionId')
              window.parent.location.href = this.feUrl + '/login.html'
            }
          },
        },
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'agentId',
            label: '代理：',
            type: 'select',
            placeholder: '请选择代理',
            rules: [{ required: true, message: '请选择代理', trigger: 'blur' }],
            selectUrl: '/agent/getAll',
            selectData: [],
            add: true,
            update: true,
            filterable: true,
          },
          {
            field: 'title',
            label: '网站名称',
            type: 'input',
            placeholder: '网站名称',
            rules: [
              { message: '请输入网站名称', trigger: 'blur', required: true },
            ],
            add: true,
            update: true,
          },
          {
            field: 'bonus',
            label: '网站累计收益',
            type: 'input',
            placeholder: '网站累计收益',
            rules: [
              {
                message: '请输入网站累计收益',
                trigger: 'blur',
                required: true,
              },
            ],
            add: false,
            update: false,
          },
          {
            field: 'run',
            label: '网站运行天数',
            type: 'input',
            placeholder: '网站运行天数',
            rules: [
              {
                message: '请输入网站运行天数',
                trigger: 'blur',
                required: true,
              },
            ],
            add: false,
            update: false,
          },
          {
            field: 'defaultPid',
            label: '代理默认pidId',
            type: 'select',
            selectData: [],
            selectUrl: '/pidSecret/getAll',
            placeholder: '请选择',
            rules: [
              {
                message: '请选择',
                trigger: 'blur',
                required: true,
              },
            ],
            add: false,
            update: false,
          },
          {
            field: 'proxyWalletPid',
            label: '代理钱包默认pidId',
            type: 'select',
            selectData: [],
            selectUrl: '/pidSecret/getAll',
            placeholder: '请选择',
            rules: [
              {
                message: '请选择',
                trigger: 'blur',
                required: true,
              },
            ],
            add: false,
            update: false,
          },  {
            field: 'feeRatio',
            label: '提现手续费比例',
            type: 'money',
            placeholder: '提现手续费比例(%)',
            rules: [{
              message: '请输入提现手续费比例', trigger: 'blur', required: true
            }],
            add: false,
            update: false,
          },{
            field: 'timeScriptKey',
            label: '时间脚本秘钥',
            type: 'input',
            placeholder: '时间脚本秘钥',
            rules: [
              {
                message: '请输入时间脚本秘钥',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          },{
            field: 'timeScriptUrl',
            label: '时间脚本服务器地址',
            type: 'input',
            placeholder: '时间脚本服务器地址',
            rules: [
              {
                message: '请输入时间脚本服务器地址',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          },{
            field: 'timeScriptSelectUrl',
            label: '时间脚本查询服务器地址',
            type: 'input',
            placeholder: '时间脚本查询服务器地址',
            rules: [
              {
                message: '请输入时间脚本查询服务器地址',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          },{
            field: 'douYinReleaseAmount',
            label: '抖音每日发布额度',
            type: 'input',
            placeholder: '抖音每日发布额度',
            rules: [
              {
                message: '请输入抖音每日发布额度',
                trigger: 'blur',
                required: true,
              },
            ],
            add: true,
            update: true,
          }
        ],
      },
    }
  },
}
</script>

<style scoped>
</style>
